import { getData, patchData, postData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';
import cacheManager from 'src/utils/cache';

export const getBodyParts = async () => {
  const url = `${urlMap.treatments.bodyParts}`;
  return getData(url);
};

export const getProcedures = async (bodyPart) => {
  const url = `${urlMap.treatments.procedures.replace('{body_part}', bodyPart)}`;
  return getData(url);
};

export const getTreatmentById = async (id) => {
  console.log('Fetching treatment with ID:', id);
  const url = `${urlMap.treatments.byId.replace('{treatmentId}', id)}`;
  const result = await getData(url);
  
  // Cache nested concern data if present
  if (result && result.concerns && Array.isArray(result.concerns)) {
    result.concerns.forEach((concern) => {
      if (concern.id) {
        const concernCacheKey = cacheManager.generateCacheKey(`/v1/concerns/${concern.id}`);
        cacheManager.set(concernCacheKey, concern);
      }
    });
  }
  
  return result;
};


export const getConcerns = async (bodyPart, procedureName) => {
  const url = `${urlMap.treatments.concerns
    .replace('{body_part}', bodyPart)
    .replace('{procedure}', procedureName)}`;
  return getData(url);
};

export const getTreatmentId = async (bodyPart, procedure, concern) => {
  const url = `${urlMap.treatments.treatmentId
    .replace('{body_part}', bodyPart)
    .replace('{procedure}', procedure)
    .replace('{concern}', concern)}`;
  return getData(url);
};

export const getProcedureName = async (treatment_id) => {
  const url = `${urlMap.treatments.procedureName.replace('{treatmentId}', treatment_id)}`;
  return getData(url);
};

export const getAllTreatments = async (pageValue = 1, limitValue = 10) => {
  const url = `${urlMap.treatments.all
    .replace('pageValue', `${pageValue}`)
    .replace('limitValue', `${limitValue}`)}`;
  const result = await getData(url);
  
  // Cache nested concern data from treatment results
  if (result && result.results && Array.isArray(result.results)) {
    result.results.forEach((treatment) => {
      if (treatment.concerns && Array.isArray(treatment.concerns)) {
        treatment.concerns.forEach((concern) => {
          if (concern.id) {
            const concernCacheKey = cacheManager.generateCacheKey(`/v1/concerns/${concern.id}`);
            cacheManager.set(concernCacheKey, concern);
          }
        });
      }
    });
  }
  
  return result;
};


export const getSelectOptions = async () => {
  const data = `${urlMap.treatments.data}`
  return getData(data);
}

export const createTreatment = async (data) => {
  const url = `${urlMap.treatments.create}`;
  const result = await postData(url, data);
  
  // Invalidate treatment lists and related packages
  cacheManager.invalidateResource('treatments');
  cacheManager.invalidate('/v1/packages');
  
  return result;
}

export const updateTreatment = async (treatmentId, data) => {
  console.log(treatmentId);
  const url = `${urlMap.treatments.update.replace('{treatmentId}', treatmentId)}`;
  const result = await patchData(url, data);
  
  // Explicitly invalidate treatment cache and related resources
  cacheManager.invalidateResource('treatments', treatmentId);
  cacheManager.invalidate('/v1/treatments');
  
  // Invalidate packages that might reference this treatment
  cacheManager.invalidate('/v1/packages');
  
  // If concerns were updated, invalidate concern cache too
  if (data.concerns) {
    cacheManager.invalidateResource('concerns');
  }
  
  return result;
}
export const searchTreatments = async (query = '') => {
  const url = `${urlMap.treatments.search}?query=${encodeURIComponent(query)}`;
  return getData(url);
};
